import { sanitize } from '@core/shared';
import { BaseApiResponse } from '@core/swagger-client';
import { useTranslation } from 'react-i18next';
import { AccessDenied, Warning } from '../Icons';

export const ErrorMessage = ({
    errorSubject,
    apiError,
    errorCode,
    statusCode,
    statusMessage,
    classNames,
    values
}: {
    errorSubject?: string;
    apiError?: BaseApiResponse;
    errorCode?: string;
    statusCode?: number;
    statusMessage?: string;
    classNames?: string;
    values?: {};
}) => {
    const { t } = useTranslation();

    errorSubject ??= 'Generic.ApiErrorCode.';
    if (errorSubject.charAt(errorSubject.length - 1) !== '.') {
        errorSubject += '.';
    }

    statusCode ??= apiError?.statusCode;
    if (!statusMessage) {
        errorCode ??= apiError?.errorCode;
        if (!errorCode) {
            statusCode ??= apiError?.statusCode;
            if (!statusCode) {
                statusCode = 500;
            }

            switch (statusCode) {
                case 409:
                    errorCode = 'ConflictException';
                    break;
                case 401:
                    errorCode = 'AccessDeniedException';
                    break;
                case 404:
                    errorCode = 'Status404NotFound';
                    break;
                case 503:
                    errorCode = 'ServiceUnavailableException';
                    break;
                case 500:
                    errorCode = 'Exception';
                    break;
            }
        }
        errorCode ??= 'Exception';

        let errorHeaderKey = errorSubject + errorCode;
        statusMessage = t(errorHeaderKey, values);
        if (statusMessage === errorHeaderKey) {
            errorSubject = 'Generic.ApiErrorCode.';
            errorHeaderKey = errorSubject + errorCode;
            statusMessage = t(errorHeaderKey, values);
            if (statusMessage === errorHeaderKey) {
                errorCode = 'Exception';
                statusMessage = t(errorSubject + errorCode, values);
            }
        }
    }

    statusMessage = sanitize(statusMessage!);
    return (
        <div role="alert" className={`flex items-center bg-warning-light pl-3 pr-4 py-2 rounded-md ${classNames}`}>
            {statusCode === 401 && <AccessDenied classNames="size-6 flex-none mr-2 stroke-warning" />}
            {statusCode !== 401 && <Warning classNames="size-6 flex-none -mt-0.5 mr-2" />}
            <span className="inline" dangerouslySetInnerHTML={{ __html: statusMessage! }}></span>
        </div>
    );
};
